import * as THREE from 'three';
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js';
import type { AmhsKitTemplateKey } from './amhsKitTemplateStore';
import { getAmhsKitTemplateFlatGroup } from './amhsKitTemplateStore';

const EXPORT_MAP: Partial<Record<AmhsKitTemplateKey, string>> = {
  CleanroomWorkcell: 'equipment/workcell.glb',
  Awp300: 'equipment/awp300.glb',
  IndustrialVerticalLifter3D: 'equipment/lifter.glb',
  Stocker3D: 'stocker/stocker3d.glb',
  CircleStocker: 'stocker/circle-stocker.glb',
  JunctionRing: 'junction/junction.glb',
  OhtVehicle: 'oht/oht.glb',
  FoupDefault: 'foup/foup.glb',
};

async function exportGroupToGlbBuffer(group: THREE.Group): Promise<ArrayBuffer> {
  const exporter = new GLTFExporter();
  return new Promise((resolve, reject) => {
    exporter.parse(
      group,
      (result) => {
        if (result instanceof ArrayBuffer) resolve(result);
        else reject(new Error('Expected binary GLB'));
      },
      reject,
      { binary: true, embedImages: true }
    );
  });
}

function downloadBuffer(filename: string, buffer: ArrayBuffer) {
  const blob = new Blob([buffer], { type: 'model/gltf-binary' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

/** Dev helper: ?exportFabGlb=1 downloads GLBs baked from live pre-sim kits. */
export async function exportCapturedAmhsKitGlbs(keys: readonly AmhsKitTemplateKey[]): Promise<void> {
  for (const key of keys) {
    const group = getAmhsKitTemplateFlatGroup(key);
    const rel = EXPORT_MAP[key];
    if (!group || !rel) continue;
    const buffer = await exportGroupToGlbBuffer(group);
    const filename = rel.split('/').pop() ?? `${key}.glb`;
    downloadBuffer(filename, buffer);
  }
}
